import { types } from 'mobx-state-tree';
const MessageDialogModel = types.model({
    open: types.boolean,
    title: types.string,
    message: types.string,
}).actions((self) => {
    function showConfirm(title, message) {
        self.title = title;
        self.message = message;
        self.open = true;
    }
    return {
        showConfirm,
    };
});
export default MessageDialogModel;
//# sourceMappingURL=MessageDialogModel.js.map